<template>
  <div class="page page--elevation online">
    <Head>
      <title>{{ pageTitle }}</title>
    </Head>
    <AdUnit unit="1" />
    <h1>
      <router-link :to="pathForLocale({ path: '/' })">{{
        $t("site-title")
      }}</router-link>
      <span class="subpage">{{ $t("map") }}</span>
    </h1>
    <ElevationReading />
    <Map
      v-if="location.longitude"
      :center="[location.longitude, location.latitude]"
    />
    <SetLocation route="map" />
    <AdUnit unit="2" />
    <ShareActions />
    <TheFooter title="View an elevation terrain map">
      <p>
        On our map page you can enter any address in the world and a pin will
        show you your location and its elevation. You can move the pin around on
        the map to find elevations of other addresses in the vicinity, or
        anywhere else you can think of. You can access this feature by clicking
        the Elevation Map link.
      </p>

      <p>
        The interactive map can be viewed in satellite mode for photographic
        representations of topography, or in satellite mode for a more standard
        map look. You can zoom in or out of the map using the + and - symbols
        located in the top right.
      </p>
    </TheFooter>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { parseUrlTitle, pathForLocale } from "@/helpers";
import ElevationReading from "@/components/ElevationReading.vue";
import SetLocation from "@/components/SetLocation.vue";
import AdUnit from "@/components/AdUnit.vue";
import ShareActions from "@/components/ShareActions.vue";
import TheFooter from "@/components/TheFooter.vue";
import Map from "@/components/Map.vue";
import { Head } from "@vueuse/head";

export default {
  components: {
    ElevationReading,
    SetLocation,
    AdUnit,
    TheFooter,
    ShareActions,
    Map,
    Head
  },
  props: {
    title: { type: String },
    latitude: { type: String },
    longitude: { type: String }
  },
  computed: {
    ...mapState(["elevation", "location"]),
    formattedTitle() {
      return parseUrlTitle(this.title);
    },
    pageTitle() {
      if (!this.formattedTitle) {
        return this.$t("elevation-map");
      }
      return `${this.formattedTitle} - ${this.$t("elevation-map")}`;
    }
  },
  methods: {
    updateLocation() {
      this.$store.dispatch("updateLocation", {
        latitude: parseFloat(this.latitude),
        longitude: parseFloat(this.longitude),
        title: this.formattedTitle
      });
      this.$store.dispatch("fetchElevation");
    },
    pathForLocale
  },
  created() {
    this.$store.dispatch(
      "setUseFeet",
      this.$t("units.feet-default") === "true"
    );
    if (this.latitude && this.longitude) {
      this.updateLocation();
    } else {
      this.$store.dispatch("watchUserLocation");
    }
  },
  watch: {
    longitude() {
      this.updateLocation();
    }
  }
};
</script>
